import BusinessCommunityBlock from './BusinessCommunityBlock'
import BusinessCommunityCardBlock from './BusinessCommunityCardBlock'

export { BusinessCommunityBlock, BusinessCommunityCardBlock }
